export interface DemandErrors {
    name?: string;
    AdvertisingSystem?: string;
    PubAccId?: string;
}

export interface ValidationResult {
    valid: boolean;
    errors: DemandErrors;
}

export const validateDemandForm = (demand: any): ValidationResult => {
    const errors: DemandErrors = {};

    if (!demand?.name?.trim()) {
        errors.name = "Demand Partner Name is required";
    }
    if (!demand?.AdvertisingSystem?.trim()) {
        errors.AdvertisingSystem = "Advertising System is required";
    }
    if (!demand?.PubAccId || demand.PubAccId.length === 0) {
        errors.PubAccId = "At least one PubAccId is required";
    }

    const valid = Object.keys(errors).length === 0;
    return { valid, errors };
};